import { axios } from '@/utils/axios';

/**
 * ANCHOR 取得檔案列表
 */
 export const getDocTemplate = async (id:string) => {
    return axios.get(`/api/template?deal_id=${id}`);
  };

/**
 * ANCHOR 取得檔案列表
 */
 export const getDocTemplateV2 = async () => {
    return axios.get(`/api/templateV2/categories`);
  };


/**
 * ANCHOR 上傳檔案
 */
 export const storeDocTemplate = async (id:string) => {
    return axios.post(`/api/template/${id}`);
  };

/**
 * ANCHOR 更新檔案
 */
 export const updateDocTemplate = async (id:string,data: []) => {
    return axios.put(`/api/template/${id}`, data);
  };

/**
 * ANCHOR 刪除檔案
 */
 export const DestroyDocTemplate = async (id: string) => {
    return axios.delete(`/api/template/${id}`);
  };

/**
 * ANCHOR 追蹤合約範本下載次數
 */
export const trackTemplateDownload = async () => {
  return axios.post('/api/template/track-download', {});
};